// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__qEAJI","emails":"CreateEditClinics_emails__2To5H","emailTagLabel":"CreateEditClinics_emailTagLabel__eL9_m"};